import { motion } from 'framer-motion';

export default function WhyNow() {
  return (
    <section data-testid="why-now-section" className="py-28 px-6 lg:px-10 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0A1628]/40 mb-6">
            Why act now
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-[#0A1628] leading-tight mb-8">
            Pilot pricing won't last
          </h2>
          <p className="text-base md:text-xl text-[#1A1A1A]/60 leading-relaxed max-w-2xl mx-auto">
            We're a new specialist firm building case studies. That means senior level attention,
            custom playbooks, and pilot pricing that won't be available once we're at capacity.
            Early clients lock in this rate permanently.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
